import React from 'react';
import { CheckboxV2, CheckboxV2Props, Flex, TextV2 } from '@withjoy/joykit';

interface ShowAvailableOnlyFacetProps
  extends Readonly<{
    isChecked: boolean;
    onToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
    title: string;
    checkboxOverrides?: CheckboxV2Props['overrides'];
  }> {}

export const ShowAvailableOnlyFacet: React.FC<ShowAvailableOnlyFacetProps> = ({ isChecked, onToggle, title, checkboxOverrides }) => {
  return (
    <Flex flexDirection="column">
      <CheckboxV2
        isChecked={isChecked}
        onChange={onToggle}
        id="show-available-only"
        overrides={checkboxOverrides}
      >
        <TextV2
          typographyVariant="body1"
          color="mono14"
        >
          {title}
        </TextV2>
      </CheckboxV2>
    </Flex>
  );
};
